<div #stickyLayout class="sticky-header product-offering-layout">
  <div
    class="sticky-header-placeholder product-offering-placeholder"
    [class.scroll-left]="stickyLayout.scrollLeft > 0"
  >
    @if (stickyLayout.scrollLeft > 0) {
      <div class="scroll-placeholder">
        <ui-button
          mkpDataTest="scroll-products-left-btn"
          mkpScrollToNext
          position="left"
          [config]="scrollConfig['left']"
          [scrollableElement]="stickyLayout"
          [itemsWrapperElement]="stickyColumns"
          [length]="products?.length"
          (click)="handleProductScroll.emit('left')"
        >
          <ui-asset name="arrow_left" />
          @if (showLabel) {
            <span>{{ 'PRODUCT_OFFERING.TABLE.SCROLL' | translate }}</span>
          }
        </ui-button>
      </div>
    }
  </div>
  <div
    #stickyColumns
    class="sticky-header-columns product-offering-columns"
    [class.center-column]="products?.length === 1"
  >
    @for (product of products; track product.code) {
      <mkp-product-sticky-header-card
        [isLoading]="isProductLoading === product.code"
        [product]="product"
        [isReadMode]="isReadMode"
        [activePlatformGroup]="activePlatformGroup"
        (handleSelectedProduct)="handleSelectedProduct.emit($event)"
      />
    }
  </div>
</div>
<section class="scroll-placeholder-wrapper">
  @if (stickyLayout.scrollWidth - stickyLayout.offsetWidth > stickyLayout.scrollLeft) {
    <div class="scroll-placeholder scroll-placeholder-right">
      <ui-button
        mkpDataTest="scroll-products-right-btn"
        mkpScrollToNext
        [config]="scrollConfig['right']"
        [scrollableElement]="stickyLayout"
        [itemsWrapperElement]="stickyColumns"
        [length]="products?.length"
        (click)="handleProductScroll.emit('right')"
      >
        <ui-asset name="arrow_right" />
        @if (showLabel) {
          <span>{{ 'PRODUCT_OFFERING.TABLE.SCROLL' | translate }}</span>
        }
      </ui-button>
    </div>
  }
</section>
